<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="菜单"
      edit-title
      form-label-width="80px"
      id-key="MenuId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="菜单名称" prop="MenuName">
          <el-input v-model="data.MenuName" placeholder="填写菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="路径" prop="Url">
          <el-input v-model="data.Url" placeholder="填写路径"></el-input>
        </el-form-item>
        <el-form-item label="上级" prop="Pid">
          <select-input
            placeholder="选择上级"
            :label="data.PName"
            v-model="data.Pid"
            @click="openMenuDialog"
          />
        </el-form-item>
        <el-form-item label="排序" prop="Sort">
          <el-input-number :min="0" v-model="data.Sort"></el-input-number>
          <span class="t-tips" v-if="!isMB">值越小排得越前</span>
        </el-form-item>
      </template>
    </common-dialog>
    <menu-dialog ref="menuDialog" title="选择上级菜单" @select="setParent"></menu-dialog>
  </div>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import editDialogMixin from "@/mixins/editDialog";
import menuDialog from "./listDialog";
import api from "@/api/sy/menu";
import selectInput from "@/components/common/selectInput";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    menuDialog,
    selectInput,
  },
  data() {
    return {
      data: {
        MenuId: 0,
        MenuName: "",
        Url: "",
        Icon: null,
        Pid: 0,
        PName: "",
        Lv: 1,
        Status: 1,
        Sort: 0,
        Idchain: "",
        NameChain: "",
        SortChain: "",
      },
      api,
      isMB: this.$store.state.isMB,
      rules: {
        MenuName: [{ required: true, message: "菜单名称不能为空" }],
        Url: [{ required: true, message: "路径不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      this.data.Pid = data.Pid;
      this.data.PName = data.PName;
      // console.log(this.data);
    },
    openMenuDialog() {
      this.$refs.menuDialog.open().then((that) => {
        that.$refs.list.getData();
      });
    },
    setParent(parent) {
      if (this.data.MenuId == parent.MenuId) {
        this.$message.error("不可以选择自己为上级");
        return;
      }
      this.data.Pid = parent.MenuId;
      this.data.PName = parent.MenuName;
      // console.log(this.data);
    },
    setSort(sort) {
      this.data.Sort = sort;
    },
  },
};
</script>